import styled, { css, keyframes } from 'styled-components';
import ChatNewConversation from './ChatNewConversation';
import { colorSchema } from 'utils/style';

const loadingKeyframes = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

const loadingKeyframesRule = css`
  ${loadingKeyframes} 1.5s infinite;
`;

export default styled(ChatNewConversation)`
  .chat-new-conversation {
    display: flex;

    &__container {
      height: 100%;
      margin-bottom: 2rem;
      padding: 2rem 1.6rem;
      overflow-y: scroll;
    }

    &__button {
      border: 0;
      background-color: ${colorSchema('white')};
      border-radius: 8px;
      box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.07);
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 1.6rem 0;
      padding: 2.4rem 1.6rem;
      width: 100%;
      &:disabled {
        opacity: 0.5;
      }
    }

    &__button-title {
      color: ${colorSchema('grey900')};
      font-size: 1.5rem;
      font-weight: bold;
      text-align: left;
    }

    &__button-subtitle {
      color: ${colorSchema('grey700')};
      font-size: 1.5rem;
      margin-top: 0.8rem;
      text-align: left;
    }

    &__loading {
      align-items: center;
      display: flex;
      height: 272px;
      justify-content: center;
    }

    &__journey-container {
      height: auto;
    }

    &__journey {
      align-items: stretch;
      border: 0;
      background-color: ${colorSchema('white')};
      border-radius: 8px;
      box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.07);
      cursor: pointer;
      display: flex;
      flex-direction: column;
      margin-bottom: 0.8rem;
      padding: 0.8rem 1rem;
      width: 100%;
      &:disabled {
        opacity: 0.5;
      }

      &--loading {
        height: 79px;
        position: relative;
        opacity: 0.5;
        padding: 0;

        &:after {
          display: block;
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          transform: translateX(-100%);
          background: linear-gradient(
            90deg,
            transparent,
            rgba(0, 0, 0, 0.1),
            transparent
          );
          animation: ${loadingKeyframesRule};
        }
      }
    }

    &__journey-header {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
      font-weight: bold;
      margin-bottom: 0.5rem;
      text-align: left;
    }

    &__journey-body {
      color: ${colorSchema('grey900')};
      font-size: 1.5rem;
      font-weight: bold;
      margin-bottom: 1rem;
      text-align: left;
    }

    &__journey-footer {
      color: ${colorSchema('grey700')};
      display: flex;
      font-size: 1.4rem;
      font-weight: bold;
      justify-content: space-between;
    }

    &__journey-load-info-container {
      display: flex;
      justify-content: space-between;
      width: 40%;
    }

    &__journey-id {
      font-weight: normal;
    }

    &__price {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
    }
  }
`;
